import styled from "styled-components";
import { palette } from "styled-theme";

const ContentHolder = styled.div`
  /* margin: 12px 0; */
  width: ${(props) => (props["fit"] === true ? "fit-content" : "auto")};
  background-color: ${(props) =>
    props["dark"] === true ? "#263238 !important" : "inherit"};
    background-color: ${(props) =>
      props["transparent"] === true ? "transparent !important" : "inherit"};

  background-color: ${palette("surfaceColor", 0)};
  padding: 16px;
  /* border: 1px solid ${palette("border", 0)}; */
`;

export default ContentHolder;
